import {
  GET_USERS_LIST,
  GET_AREAS,
  GET_AREAS_BY_USER,
  DELETE_AREA,
  SAVE_AREA_USER,
  REGISTER_USERS,
  REGISTER_AREAS,
  REGISTER_AREAS_BY_USER,
  AREA_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  users: [],
  areas: [],
  areaUser: [],
  loadingUser: false,
  loadingArea: false,
}

const areas = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_LIST:
      state = {
        ...state,
        loadingUser: true,
      }
      break
    case REGISTER_USERS:
      state = {
        ...state,
        loadingUser: false,
        users: action.payload,
      }
      break
    case GET_AREAS:
      state = {
        ...state,
        loadingArea: true,
      }
      break
    case REGISTER_AREAS:
      state = {
        ...state,
        loadingArea: false,
        areas: action.payload,
      }
      break
    case GET_AREAS_BY_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case REGISTER_AREAS_BY_USER:
      state = {
        ...state,
        areaUser: action.payload,
        loading: false,
      }
      break
    case SAVE_AREA_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case DELETE_AREA:
      state = {
        ...state,
        loading: true,
      }
      break
    case AREA_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        loadingUser: false,
        loadingArea: false,
      }
      break
    default:
      state = { ...state }
      break
  }

  return state
}

export default areas
